import React from 'react';

export const SessionContext = React.createContext(null);
